import { Component, AfterViewInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  Validators,
  ValidatorFn,
} from '@angular/forms';
import { Base } from '../common/base';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../utils/util.storage.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ModalInformacionReferidoComponent } from '../common/dialogs/modal-informacion-referido/modal-informacion-referido.component';
import { UserLoggedResponse } from '../../models/user';
import { CodigoAsesorService } from '../../services/codigo-asesor/codigo-asesor.service';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ReferidosService } from '../../services/referidos/referidos.service';
import { MatPaginator } from '@angular/material/paginator';
import { of, forkJoin } from 'rxjs';
import { AuthService } from '../../services/security/auth.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';

@Component({
  selector: 'app-seguimiento-referidos',
  templateUrl: './seguimiento-referidos.component.html',
  styleUrls: ['./seguimiento-referidos.component.css'],
})
export class SeguimientoReferidosComponent
  extends Base
  implements AfterViewInit {
  // Variables
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  frmReferidos: FormGroup;
  haveResponde: boolean = false;
  haveDataToShow: boolean = false;
  generalMessage: string = '';

  displayedColumns: string[] = [
    'nombreReferido',
    'tipoDocReferido',
    'numDocReferido',
    'programa',
    'nombreReferente',
    'tipoDocReferente',
    'numDocReferente',
    'estadoPago',
    'observaciones',
    'valoraPagar',
    'fechaPagoReferente',
    'acciones',
  ];

  dataSource = new MatTableDataSource<any>();

  tipo_id = [
    { codigo: 'BG', label: 'BG – BEBÉ GESTANTE' },
    { codigo: 'CC', label: 'CC – CÉDULA DE CIUDADANÍA' },
    { codigo: 'CE', label: 'CE – CÉDULA DE EXTRANJERÍA' },
    { codigo: 'CN', label: 'CN – NACIDO VIVO' },
    { codigo: 'PA', label: 'PA – PASAPORTE' },
    { codigo: 'PE', label: 'PE – PERMISO ESPECIAL DE PERMANENCIA' },
    { codigo: 'PT', label: 'PT – PERMISO POR PROTECCIÓN TEMPORAL' },
    { codigo: 'TI', label: 'TI – TARJETA DE IDENTIDAD' },
    { codigo: 'RC', label: 'RC – REGISTRO CIVIL DE NACIMIENTO' },
  ];

  logInfo: any;
  cedulaAsesor: any;
  loggedUser: any;
  nombre_Asesor: any;
  trackDataCarnet!: TrackData;

  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private mainCmp: MaincontainerComponent,
    private storageService: StorageService,
    private dialog: MatDialog,
    private codigoAsesorService: CodigoAsesorService,
    private referidosService: ReferidosService,
    private authService: AuthService,
    private trackingService: TrackingService
  ) {
    super();
    this.frmReferidos = this.fb.group({
      tipo_identificacion: ['', [Validators.required]],
      identificacion: [
        '',
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern('^[A-Za-z0-9]+$'),
          this.noSpacesValidator(),
        ],
      ],
    });
  }

  async ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA SEGUIMIENTO REFERIDOS');
      this.dataSource.paginator = this.paginator;
    });
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombre_Asesor = this.logInfo
      ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${this.logInfo.segundoApellido ?? ''
        }`.trim()
      : 'N/A';

    console.log('userCC:', this.cedulaAsesor);

    this.trackDataCarnet = {
      module: 'Mis referidos',
      category: 'N/A',
      submodule: 'Consulta seguimiento referidos',
      functionality: 'Consultar',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'REF_SEGUIMIENTO_REF_CONSULTAR'
    };
  }

  consultar(): void {
    if (!this.frmReferidos.valid) {
      this.generalMessage = 'Complete los campos para consultar';
      this.haveResponde = true;
      this.haveDataToShow = false;
      return;
    }

    this.spinner.show();
    this.generalMessage = '';

    const userCC: UserLoggedResponse = this.storageService.getItem('user');

    if (!userCC?.document) {
      this.spinner.hide();
      this.generalMessage = 'No se encontró el documento del asesor.';
      this.haveResponde = true;
      this.haveDataToShow = false;
      return;
    }

    const cedulaAsesor = userCC.document.split('. ')[1] || userCC.document;
    const filtros = this.frmReferidos.value;
    const tipoDocReferido = filtros.tipo_identificacion;
    const cedulaReferido = filtros.identificacion?.trim();

    this.codigoAsesorService
      .getCodigoAsesor(cedulaAsesor)
      .pipe(
        switchMap((codigoAsesor: number) =>
          this.referidosService.getReferidosPorAsesor(String(codigoAsesor))
        ),
        switchMap((referidos: any[]) => {
          if (!referidos || !referidos.length) {
            return of([]);
          }

          const referidosFiltrados = referidos.filter((ref) => {
            const numeroBackend = ref.NUMERO_DOCUMENTO_REFERIDO?.trim();
            const tipoBackend = ref.TIPO_DOCUMENTO_REFERIDO?.trim().toUpperCase();

            const numeroForm = cedulaReferido?.trim();
            const tipoForm = tipoDocReferido
              ? tipoDocReferido.split(' – ')[0].trim().toUpperCase()
              : null;

            const cumpleNumero = numeroForm ? numeroBackend === numeroForm : true;
            const cumpleTipo = tipoForm ? tipoBackend === tipoForm : true;

            return cumpleNumero && cumpleTipo;
          });

          if (referidosFiltrados.length === 0) {
            return of([]);
          }

          const requests = referidosFiltrados.map((item) =>
            this.referidosService
              .getBeneficiariosPorReferidos(item.NUMERO_DOCUMENTO_REFERIDO)
              .pipe(
                map((beneficiarios) => ({
                  nombreReferido: item.NOMBRE_REFERIDO,
                  tipoDocReferido: item.TIPO_DOCUMENTO_REFERIDO,
                  numDocReferido: item.NUMERO_DOCUMENTO_REFERIDO,
                  programa: item.PROGRAMA_REFERIDO,
                  nombreReferente: item.NOMBRE_REFRENTE,
                  tipoDocReferente: item.TIPO_DOCUMENTO_REFERENTE,
                  numDocReferente: item.NUMERO_DOCUMENTO_REFERENTE,
                  estadoGestionPago: item.ESTADO_GESTION_DE_PAGO,
                  observaciones: item.OBSERVACIONES,
                  valoraPagar: item.VALOR_A_PAGAR,
                  fechaPagoReferente: item.FECHA_DE_PAGO_REFERENTE,
                  tieneBeneficiarios: beneficiarios?.length > 0,
                })),
                catchError(() =>
                  of({
                    nombreReferido: item.NOMBRE_REFERIDO,
                    tipoDocReferido: item.TIPO_DOCUMENTO_REFERIDO,
                    numDocReferido: item.NUMERO_DOCUMENTO_REFERIDO,
                    programa: item.PROGRAMA_REFERIDO,
                    nombreReferente: item.NOMBRE_REFRENTE,
                    tipoDocReferente: item.TIPO_DOCUMENTO_REFERENTE,
                    numDocReferente: item.NUMERO_DOCUMENTO_REFERENTE,
                    estadoGestionPago: item.ESTADO_GESTION_DE_PAGO,
                    observaciones: item.OBSERVACIONES,
                    valoraPagar: item.VALOR_A_PAGAR,
                    fechaPagoReferente: item.FECHA_DE_PAGO_REFERENTE,
                    tieneBeneficiarios: false,
                  })
                )
              )
          );

          return forkJoin(requests);
        })
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          this.dataSource.data = data;
          this.haveResponde = true;
          this.haveDataToShow = data.length > 0;
          this.generalMessage = this.haveDataToShow
            ? ''
            : 'NO SE ENCONTRÓ INFORMACIÓN CON LOS DATOS INGRESADOS.';

          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.paginator.length = data.length;
            this.paginator.pageSize = 5;
          });
        },
        error: () => {
          this.spinner.hide();
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.generalMessage =
            'Error al consultar los datos. Inténtalo de nuevo más tarde.';
        },
      });
  }

  abrirModal(row: any): void {
    this.dialog.open(ModalInformacionReferidoComponent, {
      disableClose: true,
      data: {
        documento: row.numDocReferido,
      },
    });
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmReferidos.controls;
  }

  noSpacesValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const hasSpaces = /\s/.test(control.value);
      return hasSpaces ? { noSpaces: true } : null;
    };
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  clear(): void {
    this.frmReferidos.reset();
    this.generalMessage = '';
    this.haveResponde = false;
    this.haveDataToShow = false;
    this.dataSource.data = [];
  }
}
